import {autoRegister, resolve} from "../../../container";
import {PageScrollbar} from "../../../common/pageScrollbar";
import {PageFeatures} from "../pageFeatures";
import {EventBus, EventBusEvent} from "../../../common/eventBus";
import {DIALOG_CLOSED_EVENT, DIALOG_OPENED_EVENT, type EopDialog} from "./dialog";
import {generateUuid} from "../../../common/crypto";
import {elementFrom} from "../../../common/utils/html";

@autoRegister()
export class Dialogs {

    public constructor(
        private pageScrollbar: PageScrollbar = resolve(PageScrollbar),
        private pageFeatures: PageFeatures = resolve(PageFeatures),
        eventBus: EventBus = resolve(EventBus)
    ) {
        eventBus.on(DIALOG_CLOSED_EVENT, () => this.cleanUp());
        eventBus.on(DIALOG_OPENED_EVENT, event => this.closeOtherDialogs(event));
    }

    public async open(dialogId: string): Promise<void> {
        const dialog = this.pageFeatures.findFirst<EopDialog>(`eop-dialog[id='${dialogId}']`);
        if (dialog) {
            await dialog.updateComplete;
            if (!dialog.isOpen()) {
                await dialog.showModal();
                this.pageScrollbar.disablePageScrollability();
            }
        }
    }

    public create(dialogContent: string | HTMLElement): string {
        const dialogId = generateUuid();
        const dialog = elementFrom<EopDialog>(`
            <eop-dialog id="${dialogId}">
                <div eop-slot="dialog-content" class="dialog-content"></div>
            </eop-dialog>
        `);
        const dialogContentElement = dialog.querySelector(".dialog-content")!;
        if (dialogContent instanceof HTMLElement) {
            dialogContentElement.appendChild(dialogContent);
        } else {
            dialogContentElement.innerHTML = dialogContent;
        }
        this.pageFeatures.insert(dialog);
        return dialogId;
    }

    private closeOtherDialogs(event: EventBusEvent): void {
        const openingDialog = event.data as EopDialog;
        this.allDialogs()
            .filter(dialog => dialog.id !== openingDialog.id)
            .filter(dialog => dialog.isOpen())
            .forEach(dialog => dialog.close());
    }

    private cleanUp(): void {
        if (this.noOpenDialog()) {
            this.pageScrollbar.enablePageScrollability();
        }
    }

    private noOpenDialog(): boolean {
        return this.allDialogs()
            .filter(dialog => dialog.isOpen())
            .isEmpty();
    }

    private allDialogs(): EopDialog[] {
        return Array.from(this.pageFeatures.find<EopDialog>("eop-dialog"));
    }
}